import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }


  getDDMMYYYYfromEPOC(value: any) {
    const date = new Date(value);
    if (!value || isNaN(date.getTime())) {
      return '';
    }
    let d = date.getDate().toString();
    let m = (date.getMonth() + 1).toString();
    const y = date.getFullYear().toString();
    if (d.length === 1) {
      d = '0' + d;
    }
    if (m.length === 1) {
      m = '0' + m;
    }
    return d + '/' + m + '/' + y;
  }

  getFormattedDateWithAMPM(value: any) {
  if (value) {
    const date = new Date(value);

    let d = date.getDate();
    let m = date.getMonth() + 1; // months are 0-based
    const y = date.getFullYear();

    let hours = date.getHours();
    let minutes: any = date.getMinutes();

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;

    // pad day and month
    const dd = d < 10 ? '0' + d : d.toString();
    const mm = m < 10 ? '0' + m : m.toString();

    return `${dd}/${mm}/${y} ${hours}:${minutes} ${ampm}`;
  } else {
    return "";
  }
}

  dateToTimestamp(date: any): number {
    if (!date) return 0;
    
    if (date.year && date.month && date.day) {
      const dateObj = new Date(date.year, date.month - 1, date.day);
      if (isNaN(dateObj.getTime())) {
        return 0;
      }
      return dateObj.getTime();
    }
    
    if (date instanceof Date) {
      return date.getTime();
    }
    
    if (typeof date === 'number') {
      return date;
    }
    
    return 0;
  }

}
